import { useMutation } from 'react-query'
import { HeadingPages } from '../../../components/HeadingPages'
import { api } from '../../../services/api'
import { Loader } from '../../../components/ComponentLoader/Loader'
import InputFloating from '../../../components/InputFloating'
import { Box, Button, Flex, Table, TableContainer, Tbody, Thead } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { Item } from './Item'

import { Head } from './Head'
import { formatPrice } from '../../../utils/formatPrice'
import { useEffect } from 'react'
import { useExcelGenerator } from '../../../hooks/useExcelGenerator'
import { format } from 'date-fns'

async function getImpostoCompra(params) {
  const { dataDe, dataAte, imposto } = params
  const response = await api.get('/site/v2/crm-controle/lista-imposto-compra', {
    params: {
      data_inicio: dataDe,
      data_final: dataAte,
      porcentagem: imposto,
    },
  })

  const colorWithDifal = {
    Sim: 'green.500',
    Não: 'red.500',
  }

  return response.data
    .sort((a, b) => new Date(b.data_negociacao) - new Date(a.data_negociacao))
    .map((item) => {
      return {
        ...item,
        vlr_unit: formatPrice(item.vlr_unit),
        vlr_total: formatPrice(item.vlr_total),
        desc: formatPrice(item.desc),
        vlr_liq: formatPrice(item.vlr_liq),
        vlr_imp: formatPrice(item.vlr_imp),
        tot_imp: formatPrice(item.tot_imp),
        descricao: item.descricao.toLowerCase(),
        colorDifal: colorWithDifal[item.difal],
        qtd: new Intl.NumberFormat('pt-BR').format(item.qtd),
        dt_compra: item?.dt_compra ? format(new Date(item.dt_compra), "dd/MM/yyyy 'às' HH:mm") : '-',
        outras_despesas: formatPrice(item.outras_despesas),
        valor_sub: formatPrice(item.valor_sub),
        base_icms: formatPrice(item.base_icms),
        original_dt_compra: item.dt_compra,
        fcp_st: formatPrice(item.fcp_st),
      }
    })
    .filter((item) => parseFloat(item.porc_imp) > 0)
}

export function ImpostoCompra() {
  const { handleSubmit, register } = useForm()
  const { generateExcel, loading } = useExcelGenerator()

  const { data, isLoading, mutateAsync } = useMutation({
    mutationFn: getImpostoCompra,
    onSuccess: (data) => {
      console.log(data)
    },
  })

  const onSubmit = async (values) => {
    const { dataDe, dataAte, imposto } = values

    try {
      await mutateAsync({
        dataDe,
        dataAte,
        imposto,
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const now = new Date()
    //do mes atual até o dia atual
    const dataDe = new Date(now.getFullYear(), now.getMonth(), 1).toISOString()
    const dataAte = now.toISOString()

    const imposto = 0

    mutateAsync({
      dataDe,
      dataAte,
      imposto,
    })
  }, [])

  async function handleGenerateExcel() {
    try {
      const header = [
        'Razão Social',
        'Data do pedido',
        'Cód',
        'Descrição',
        'Nfe. Venda',
        'Nfe. Remessa',
        'Ped. Venda',
        'PEDIDO COMPRA',
        'Dt. Compra',
        'NCM',
        'Cod. Forn',
        'COR',
        'Quantidade',
        'Valor unitário',
        'Valor total',
        'Valor líquido',
        'Valor imposto',
        'Total imposto',
        '% Imposto',
        'DIFAL',
        'CEST',
        'Outras Despesas',
        'VLR Sub. NFE',
        'Base ICMS',
        'FCP SP',
      ]

      const dataTable = data?.map((item) => {
        return {
          'Razão Social': item.razao_socialforn,
          'Data do pedido': item.data_negociacao ? format(new Date(item.data_negociacao), "dd/MM/yyyy 'às' HH:mm") : '-',
          Cód: item.codigo_produto,
          Descrição: item.descricao,
          'Nfe. Venda': item.nfe_venda,
          'Nfe. Remessa': item.nfe_compra,
          'Ped. Venda': item.ped_venda,
          'PEDIDO COMPRA': item.numero_nota,
          'DT. Compra': item.dt_compra,
          NCM: item.ncm,
          'Cod. Forn': item.cod_forn,
          COR: item.cor,
          Quantidade: item.qtd,
          'Valor unitário': item.vlr_unit,
          'Valor total': item.vlr_total,
          'Valor líquido': item.vlr_liq,
          'Valor imposto': item.vlr_imp,
          'Total imposto': item.tot_imp,
          '% Imposto': item.porc_imp,
          DIFAL: item.difal,
          CEST: item.cest,
          'Outras Despesas': item.outras_despesas,
          'VLR Sub. NFE': item.valor_sub,
          'Base ICMS': item.base_icms,
          'FCP ST': item.fcp_st,
        }
      })

      await generateExcel(header, dataTable, 'Imposto Compra')
    } catch (error) {
      console.log(error)
    }
  }

  console.log(data)

  return (
    <>
      <HeadingPages name="Fechamento Imposto Compra" />

      {isLoading && <Loader img={'https://imgproductioncrm.s3.us-east-2.amazonaws.com/loading-verde.gif'} />}

      <Box display="flex" flexDir="column" gap="4" alignItems="center" justifyContent="center" mb="2rem" px="4">
        <Flex alignItems="flex-start" gap={2} as="form" onSubmit={handleSubmit(onSubmit)} mt={5}>
          <InputFloating label="De" {...register('dataDe')} type="date" />
          <InputFloating label="Até" {...register('dataAte')} type="date" />
          <InputFloating label="% de Imposto" {...register('imposto')} />
          <Button type="submit" variant="outline" w="full" maxW="120px">
            Buscar
          </Button>
        </Flex>

        <Button colorScheme="green" w="full" maxW="150px" onClick={handleGenerateExcel} isLoading={loading}>
          Exportar Planilha
        </Button>

        {!isLoading && (
          <TableContainer
            maxW="1480px"
            w="full"
            mt="1rem"
            size="sm"
            maxH="500px"
            overflowY="scroll"
            boxShadow="md"
            borderRadius="md"
            border="1px solid #e2e8f0"
            minH="650px"
          >
            <Table variant="simple">
              <Thead position="sticky" top="0" bg="#E2E8F0">
                <Head />
              </Thead>
              <Tbody>
                {data?.map((item) => (
                  <Item key={item.numero_nf} item={item} />
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </>
  )
}
